import { inject, Injectable } from '@angular/core';

import { defaultDeviceProfile } from 'app/features/settings/models';
import { Activity, defaultActivity } from 'app/shared/features/activity-selector/models';
import { MasterData } from 'app/shared/models';

import { DeviceInfoStorageService } from './device-info-storage.service';
import { StorageService } from './storageService';

export const masterDataKey = 'master-data';

@Injectable({ providedIn: 'root' })
export class MasterDataStorageService {
    private storage = inject(StorageService);
    private deviceInfoStorageService = inject(DeviceInfoStorageService);

    clearMasterData(): void {
        this.storage.clear(masterDataKey);
    }

    putMasterDataToStorage(newMasterData: MasterData) {
        this.storage.store<MasterData>(masterDataKey, newMasterData);
    }

    getMasterDataFromStore(): MasterData | undefined {
        const fetched = this.storage.get<Partial<MasterData>>(masterDataKey);
        if (!fetched) return undefined;

        const deviceName = fetched.deviceName || this.deviceInfoStorageService.getOrAddDeviceId();
        return {
            activities:
                fetched.activities?.map((fetchedActivity) => partialToActivity(fetchedActivity)) || [],
            date: fetched.date || 0,
            maps: fetched.maps || [],
            containers: fetched.containers || [],
            employees: fetched.employees || [],
            productBoxes: fetched.productBoxes || [],
            locations: fetched.locations || [],
            deviceName,
            deviceProfile: fetched.deviceProfile || defaultDeviceProfile,
        };
    }

    getDeviceNameFromMasterDataStore(): string {
        const fetched = this.storage.get<Partial<MasterData>>(masterDataKey);
        // Not all masterData may contain a deviceName but there will be a deviceId in the storage
        // DeviceId will be displayed in HelpInfo if deviceName is not available
        return fetched?.deviceName || this.deviceInfoStorageService.getOrAddDeviceId();
    }
}

function partialToActivity(fetchedActivity: Partial<Activity>): Activity {
    return {
        ...defaultActivity(),
        ...fetchedActivity,
    };
}
